import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IEecsCancellation, IEecsCancellationModal } from '../types/eecs-cancellations.types';

interface EecsCancellationsInitialState extends BaseDataReducerInitialState<IEecsCancellation> {
  selectedCancellation: IEecsCancellation | null;
  currentModal: IEecsCancellationModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<IEecsCancellation, EecsCancellationsInitialState>(
  'eecs-cancellations',
);

const eecsCancellationsInitialState: EecsCancellationsInitialState = {
  ...initialState,
  perPage: 25,
  selectedCancellation: null,
  currentModal: null,
};

export const eecsCancellations = createSlice({
  name: 'eecsCancellations',
  initialState: eecsCancellationsInitialState,
  reducers: {
    setSelectedEecsCancellation(state, action: PayloadAction<IEecsCancellation | null>) {
      state.selectedCancellation = action.payload;
    },
    setEecsCancellationModal(state, action: PayloadAction<IEecsCancellationModal | null>) {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as EecsCancellationsInitialState, action);
    });
  },
});

export const EecsCancellationsAC = AC;
export const onEecsCancellationsSort = thunks.onSort;
export const onEecsCancellationsFilter = thunks.onFilter;
export const setEecsCancellationsCurrentPage = AC.setCurrentPage;

export const { setSelectedEecsCancellation, setEecsCancellationModal } = eecsCancellations.actions;
